import React from "react";

/**
 * Text/password input with a decorative icon on the left (login + signup modals).
 */
export default function AuthInputWrap({ icon, password, children }) {
  return (
    <div
      className={
        "input_icon_wrap" + (password ? " input_icon_wrap--password" : "")
      }
    >
      <i className={`${icon} input_icon_left`} aria-hidden="true" />
      {children}
    </div>
  );
}
